export default __webpack_public_path__ + "static/media/ico_user_guide2.df41006e.png";